import { Body, Box } from './'
import './HoverToolTip.scss'

export const HoverTooltip = ({ text, position = 'top', children }) => {
  return (
    <Box className="tooltip-container" container>
      {children}
      <Box className={`tooltip-box tooltip-${position}`}>
        <Body bold alt size={12}>
          {text}
        </Body>
      </Box>
    </Box>
  )
}